import firebase from "firebase/app";

const db = firebase.firestore();

let userId = null;

export default {
  setUserId(uid) {
    userId = uid;
    if (userId) {
      this.updateLastLogin();
    }
  },
  updateLastLogin() {
    db.collection("users").doc(userId).set(
      {
        _lastSeen: new Date(),
      },
      { merge: true }
    );
  },
  collection(path) {
    return db.doc(`users/${userId}`).collection(path);
  },
  doc(path) {
    return db.doc(`users/${userId}/${path}`);
  },
  userProfile() {
    return db.doc(`users/${userId}`);
  },
  snapshotToArray(snapshot) {
    const result = [];
    snapshot.forEach((doc) => {
      const item = doc.data();
      item.id = doc.id;
      result.push(item);
    });
    return result;
  },
};
